module.exports = __webpack_public_path__ + "img/aanleg1.15bc7178.jpg";